import { ModalPortalContext } from '@glow/ui-components'
import { Map } from 'immutable'
import React, { Children, ReactNode } from 'react'

import { connect } from 'react-redux'
import { closeModal } from '../actions/creators/helpers'
import Area from '../primitives/Area'
import Close from '../primitives/Close'
import Overlay from '../primitives/Overlay'
import { AppStateType } from '../utils/appStateReduxStore'

class Modal extends React.Component<Props, { portalContainer: HTMLElement | null }> {
  state = { portalContainer: null }

  setPortalContainer = (portalContainer: HTMLElement | null) => {
    if (portalContainer !== this.state.portalContainer) this.setState({ portalContainer })
  }

  render() {
    const { zIndex, modal, fullscreen, large, tall, keepStateOnClose = false, listOverflow } = this.props
    if (!modal.get('className')) return null

    let component = null
    Children.forEach(this.props.children, (c: any) => {
      if (c.type === modal.get('className')) {
        component = c
      }
    })

    if (!component) return null

    const modalProps = modal.get('props')
    let includeOverlay = true
    if (modalProps && modalProps.includeOverlay !== undefined) includeOverlay = modalProps.includeOverlay

    const closeModal = modalProps && modalProps.closeModal !== undefined ? modalProps.closeModal : this.props.closeModal

    return (
      <div className="modal-wrapper" style={{ zIndex: (zIndex + 1) * 10 }}>
        {/* Area is z-index 9999, so design-system dropdowns portalled to body would render behind the modal */}
        <div
          ref={this.setPortalContainer}
          className="fixed inset-0 z-10000 pointer-events-none *:pointer-events-auto"
        />
        <ModalPortalContext.Provider value={this.state.portalContainer}>
          <div className="modal" onKeyDown={(e) => (e.key === 'Escape' ? closeModal(keepStateOnClose) : null)}>
            {includeOverlay && (
              <>
                <Overlay
                  onClick={() => {
                    closeModal(keepStateOnClose)
                  }}
                />
                <Area fullscreen={fullscreen} large={large} tall={tall} listOverflow={listOverflow}>
                  <Close
                    onClick={() => {
                      closeModal(keepStateOnClose)
                    }}
                  />
                  {React.cloneElement(component, { ...this.props, ...modalProps })}
                </Area>
              </>
            )}
            {!includeOverlay && React.cloneElement(component, { ...this.props, ...modalProps })}
          </div>
        </ModalPortalContext.Provider>
      </div>
    )
  }
}

interface OwnProps {
  fullscreen?: boolean
  tall?: boolean
  listOverflow?: boolean
  large?: boolean
  keepStateOnClose?: boolean
  children: ReactNode
}

interface StateProps {
  modal: Map<string, any>
  zIndex: number
}

interface DispatchProps {
  closeModal: (keepState?: boolean) => void
}

type Props = OwnProps & StateProps & DispatchProps

export default connect<StateProps, DispatchProps, OwnProps, AppStateType>(
  (state) => ({
    modal: state.get('modal'),
    zIndex: 100
  }),
  { closeModal }
)(Modal)
